import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { MODULE_IDS } from "../../constants/enums";
import { APP_FILE_LEGAL_LIST, APP_FILE_LEGAL_PLUS } from "./legals.constants";

const LegalList = Loadable(
  lazy(() =>
    import("./LegalsTabs").then(({ LeagalsTabs }) => ({
      default: LeagalsTabs,
    }))
  )
);
const LegalPlus = Loadable(
  lazy(() =>
    import("./ManageLegalTabs").then(({ ManageLegalTabs }) => ({
      default: ManageLegalTabs,
    }))
  )
);

export const legalRoutes = [
  {
    path: `${APP_FILE_LEGAL_LIST}/`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.LEGAL]}>
        <LegalList />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${APP_FILE_LEGAL_PLUS}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.LEGAL]}>
        <LegalPlus />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${APP_FILE_LEGAL_PLUS}/:legalCode`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.LEGAL]}>
        <LegalPlus />
      </AuthorizedRoute>
    ),
  },
];
